import { fetchUserProfileClient } from "@services/userProfileClient";
import { trackEventWithCommonProps, EventType } from "@utils/eventTracker";
import { getClientCookie } from "@lib/cookies.client";

const LEAD_DATA_KEY = "leadData";


export const getLeadData = async (): Promise<Record<string, any>> => {
  if (typeof window === "undefined") return {};
  
  try {
    // Try sessionStorage first
    const sessionData = sessionStorage?.getItem(LEAD_DATA_KEY);
    if (sessionData) {
      return JSON.parse(sessionData);
    }
    
    // Fallback to localStorage
    const localData = localStorage?.getItem(LEAD_DATA_KEY);
    if (localData) {
      return JSON.parse(localData);
    }
    
    const contactNumber = sessionStorage?.getItem("contact_number");
    if (contactNumber) {
      return { phone: contactNumber };
    }
        
        try {
          const profileResponse = await fetchUserProfileClient();
          if (profileResponse.errorStatus) {
            const ackoDriveTokens = getClientCookie("ackodrive_tokens");
            await trackEventWithCommonProps("exception", EventType.TRACK_EVENT, {
              additionalProps: {
                exception_type: "api_error",
                exception_name: "failed_profile_fetch_for_lead_data",
                vehicle_make: profileResponse.error,
              },
            });
            
            console.error("[Lead Data Storage] Failed to fetch profile:", profileResponse.error);
          } else {
            const phoneNumber = profileResponse.data?.contact_no;
            if (phoneNumber) {
              console.log("[Lead Data Storage] ✅ Phone number retrieved from profile API:", phoneNumber);
              return { phone: phoneNumber };
            }
          }
        } catch (error: any) {
          const ackoDriveTokens = getClientCookie("ackodrive_tokens");
          await trackEventWithCommonProps("exception", EventType.TRACK_EVENT, {
            additionalProps: {
              exception_type: "api_error",
              exception_name: "failed_profile_fetch_for_lead_data",
              vehicle_make: error?.message || "Unknown error",
            },
          });
          
          console.error("[Lead Data Storage] Exception fetching profile:", error);
        }
    
    return {};
  } catch (error) {
    console.error("[Lead Data Storage] Error in getLeadData:", error);
    return {};
  }
};

export const setLeadData = (data: Record<string, any>): void => {
  if (typeof window === "undefined") return;
  
  try {
    const jsonString = JSON.stringify(data);
    sessionStorage.setItem(LEAD_DATA_KEY, jsonString);
    localStorage.setItem(LEAD_DATA_KEY, jsonString);
  } catch (error) {
    console.error("Error saving lead data:", error);
  }
};

export const clearLeadData = (): void => {
  if (typeof window !== "undefined" && typeof localStorage !== "undefined") {
    localStorage.removeItem(LEAD_DATA_KEY);
  }
};

